@if (access.state === 'granted' || access.state === 'monitoring') {
  <admin-top-nav [user]="access.currentUser" [monitoringMode]="monitoringMode"></admin-top-nav>
  <ui-toast-outlet [toasts]="toasts" (dismissToast)="dismissToast($event)"></ui-toast-outlet>
}
<main class="shell">
  @if (availableUpdate) {
    <div class="build-update-banner" role="status" aria-live="polite">
      <div class="build-update-banner__content">
        <strong>{{ 'admin.shell.versionUpdateTitle' | adminTranslate }}</strong>
        <p>{{ 'admin.shell.versionUpdateMessage' | adminTranslate:{ version: updateBannerVersion, buildId: updateBannerBuildId } }}</p>
      </div>
      <ui-button (click)="refreshForUpdate()">{{ 'admin.shell.versionUpdateAction' | adminTranslate }}</ui-button>
    </div>
  }
  @if (access.state === 'checking') {
    <ui-card class="access-card">
      <p class="eyebrow">{{ 'admin.nav.backoffice' | adminTranslate }}</p>
      <h1>{{ 'admin.shell.checkingTitle' | adminTranslate }}</h1>
      <p class="lede">{{ 'admin.shell.checkingText' | adminTranslate }}</p>
    </ui-card>
  } @else if (access.state === 'unauthenticated') {
    <ui-card class="access-card">
      <p class="eyebrow">{{ 'admin.nav.backoffice' | adminTranslate }}</p>
      <h1>{{ 'admin.shell.loginRequiredTitle' | adminTranslate }}</h1>
      <p class="lede">{{ 'admin.shell.loginRequiredText' | adminTranslate }}</p>
      <ui-button [href]="api.loginUrl">{{ 'admin.shell.login' | adminTranslate }}</ui-button>
    </ui-card>
  } @else if (access.state === 'forbidden') {
    <ui-card class="access-card">
      <p class="eyebrow">{{ 'admin.nav.backoffice' | adminTranslate }}</p>
      <h1>{{ 'admin.shell.forbiddenTitle' | adminTranslate }}</h1>
      <p class="lede">{{ 'admin.shell.forbiddenText' | adminTranslate }}</p>
    </ui-card>
  } @else if (access.state === 'monitoringLogin') {
    <ui-card class="access-card">
      <p class="eyebrow">{{ 'admin.nav.backoffice' | adminTranslate }}</p>
      <h1>{{ 'admin.shell.monitoringTitle' | adminTranslate }}</h1>
      <p class="lede">{{ 'admin.shell.monitoringText' | adminTranslate }}</p>
      <div class="monitoring-form">
        <label>
          <span>{{ 'admin.shell.monitoringUsername' | adminTranslate }}</span>
          <input type="text" [(ngModel)]="monitoringUsername" autocomplete="username">
        </label>
        <label>
          <span>{{ 'admin.shell.monitoringPassword' | adminTranslate }}</span>
          <input type="password" [(ngModel)]="monitoringPassword" autocomplete="current-password">
        </label>
        @if (monitoringError) {
          <p class="monitoring-error">{{ monitoringError | adminTranslate }}</p>
        }
        <ui-button (click)="enterMonitoringMode()" [disabled]="monitoringLoading || !monitoringUsername.trim() || !monitoringPassword">
          {{ monitoringLoading ? ('admin.common.loading' | adminTranslate) : ('admin.shell.monitoringLogin' | adminTranslate) }}
        </ui-button>
      </div>
    </ui-card>
  } @else if (canRenderRoute) {
    <router-outlet />
  } @else {
    <ui-card class="access-card">
      <p class="eyebrow">{{ 'admin.nav.backoffice' | adminTranslate }}</p>
      <h1>{{ 'admin.shell.monitoringRouteTitle' | adminTranslate }}</h1>
      <p class="lede">{{ 'admin.shell.monitoringRouteText' | adminTranslate }}</p>
      <ui-button (click)="goToOverview()">{{ 'admin.nav.overview' | adminTranslate }}</ui-button>
    </ui-card>
  }
</main>
<ui-footer
  [copyrightTemplate]="'© {{year}} Freyr Admin.'"
  cguLabel="CGU"
  privacyLabel="Politique de confidentialite"
  cguUrl="/#/overview"
  privacyUrl="/#/overview">
</ui-footer>
